import {
  Button,
  createStyles,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Theme,
  WithStyles,
  withStyles,
  Divider,
  Typography,
  AppBar,
  Tabs,
  Tab,
  MenuItem,
  FormControl,
  Select,
  InputLabel,
  ButtonBase,
  Paper,
  Grid,
  IconButton,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  List,
  ListItem,
  ListItemText,
  DialogContentText,
  ListItemAvatar,
  Avatar,
  Chip,
  Badge,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import * as React from "react";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import {
  isEmpty,
  PHONE_REG_EXP,
  PROVINCES,
  getInspectionLabel,
  getMomentDate,
  convertToBoolean,
} from "../constants/constants";

import TabPanel from "../components/TabPanel";
import EditableTableComponent from "../components/EditableTableComponent";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import imagePlacholder from "../assets/images/image-placeholder.png";
import RenderImagesDialog from "./RenderImagesDialog";
import { AssetsService } from "../services/AssetsService";
import DateFnsUtils from "@date-io/date-fns";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import moment from "moment";
import { TimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import AddInspectionCategoryDialog from "./AddInspectionCategoryDialog";
import ChipComponent from "../components/ChipComponent";
import AddScheduleDialog from "./AddScheduleDialog";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import StopIcon from "@material-ui/icons/Stop";
import LooksOneIcon from "@material-ui/icons/LooksOne";
import LoopIcon from "@material-ui/icons/Loop";
export const types = {
  DIALOG_INFO: "DIALOG_INFO",
  DIALOG_INPUT: "DIALOG_INPUT",
  DIALOG_ACTION: "DIALOG_ACTION",
  DIALOG_ERROR: "DIALOG_ERROR",
};
export const MODE_TYPE = {
  ADD: "ADD",
  EDIT: "EDIT",
};
const CustomChecked = withStyles({
  colorSecondary: {
    "&.Mui-checked + .MuiSwitch-track": {
      backgroundColor: "orange",
    },
  },
})(Checkbox);
const styles = (theme: Theme) =>
  createStyles({
    chip: {
      margin: theme.spacing(0.5),
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      flexBasis: "33.33%",
      flexShrink: 0,
    },
    secondaryHeading: {
      fontSize: theme.typography.pxToRem(15),
      color: theme.palette.text.secondary,
    },
    image: {
      width: 128,
      height: 128,
    },
    img: {
      "max-width": 120,
      "max-height": 120,
      overflow: "hidden",
    },
    root: {
      width: "100%",
    },
  });
const addCompanyValidationSchema = Yup.object().shape({
  name: Yup.string().required("Company name is required"),
  email: Yup.string().email("Email not valid").notRequired(),
  phone: Yup.string()
    .length(10, "Phone number needs to be 10 digits")
    .max(10, "Phone number needs to be 10 digits")
    .matches(PHONE_REG_EXP, "Please enter a valid mobile number.")
    .notRequired(),
});
interface Props extends WithStyles<typeof styles> {
  title: any;
  open: any;
  mode: any;
  companyData?: any;
  handleClose: any;
  handleOnSubmit: any;
}

class AddCompanyDialog extends React.Component<Props> {
  state = {
    showPassword: false,
    sameAsAbove: false,
    hasError: false,
    hasSetValues: false,
    departments: Array<any>(),
    sections: Array<any>(),
    inspectionTypes: Array<any>(),
    activityFlowLegends: Array<any>(),
    machinineryTypes: Array<any>(),
    contractingTypes: Array<any>(),
    operations: Array<any>(),
    positions: Array<any>(),
    shifts: Array<any>(),

    schedules: Array<any>(),

    inspectionFrequencies: Array<any>(),
    departmentValue: { value: "", title: "" },
    sectionValue: { value: "", title: "" },
    machinineryValue: { value: "", label: "" },
    workflows: false,
    inspectionTypeValue: { value: "", label: "", categories: new Array<any>() },
    positionValue: { value: "", label: "" },
    operationValue: { value: "", label: "" },
    shiftValue: {
      value: "",
      label: "",
      startOfShift: moment(new Date(), "HH:mm").format("HH:mm").toString(),
      endOfShift: moment(new Date(), "HH:mm").format("HH:mm").toString(),
    },
    contractingTypeValue: { id: -1, name: "" },
    activityFlowLegendsValue: { code: "", definition: "" },
    inspectionFrequencyValue: { value: "", label: "" },
    contractors: new Array<any>(),
    value: 0,
    selectedImageItem: { base64: "", item: { filename: "", _id: "" } },
    openRenderImagesDialog: false,
    openConfimDelete: false,
    openSchedulerConfimDelete: false,
    openScheduleDialog: false,
    timeCaptureError: "",

    expanded: false,

    addCategory: false,
    inspectionTypesAccordion: [],
    selectedInspectionTypeIndex: -1,
    lookupData: {},
    openEditActivityFlowLegendsValueDialog: false,
    openEditShiftsValueDialog: false,
    nIndexActivityFlowLegendsValueSelected: -1,
    nIndexShiftValueSelected: -1,

    selectedScheduler: {},
    selectedSchedulerIndex: -1,
  };

  componentDidMount = () => {
    this.setState(
      {
        workflows:
          this.props.companyData && this.props.companyData.workflows
            ? this.props.companyData.workflows
            : false,
        departments:
          this.props.companyData && this.props.companyData.departments
            ? this.props.companyData.departments
            : Array<any>(),
        sections:
          this.props.companyData && this.props.companyData.sections
            ? this.props.companyData.sections
            : Array<any>(),
        inspectionTypes:
          this.props.companyData && this.props.companyData.inspectionTypes
            ? this.props.companyData.inspectionTypes
            : Array<any>(),
        contractingTypes:
          this.props.companyData && this.props.companyData.contractingTypes
            ? this.props.companyData.contractingTypes
            : Array<any>(),
        activityFlowLegends:
          this.props.companyData && this.props.companyData.activityFlowLegends
            ? this.props.companyData.activityFlowLegends
            : Array<any>(),
        machinineryTypes:
          this.props.companyData && this.props.companyData.machinineryTypes
            ? this.props.companyData.machinineryTypes
            : Array<any>(),
        operations:
          this.props.companyData && this.props.companyData.operations
            ? this.props.companyData.operations
            : Array<any>(),
        shifts:
          this.props.companyData && this.props.companyData.shifts
            ? this.props.companyData.shifts
            : Array<any>(),
        schedules:
          this.props.companyData && this.props.companyData.schedules
            ? this.props.companyData.schedules
            : Array<any>(),
        positions:
          this.props.companyData && this.props.companyData.positions
            ? this.props.companyData.positions
            : Array<any>(),
        inspectionFrequencies:
          this.props.companyData && this.props.companyData.inspectionFrequencies
            ? this.props.companyData.inspectionFrequencies
            : Array<any>(),
        contractors:
          this.props.companyData && this.props.companyData.contractors
            ? this.props.companyData.contractors
            : Array<any>(),
        selectedImageItem:
          this.props.companyData && this.props.companyData.imageItem
            ? this.props.companyData.imageItem
            : { base64: "", item: { filename: "", _id: "" } },
      },
      () => {
        this.downloadQuestionAsset(this.state.selectedImageItem);
        this.setLookupData();
        this.setUpInspectionTypesAccordion();
      }
    );
  };

  setUpInspectionTypesAccordion = () => {
    let accordion = new Array<any>();
    this.state.inspectionTypes.map((item: any) => {
      let expandedItem = {
        title: item.label,
        expanded: false,
        categories: item.categories,
      };
      accordion.push(expandedItem);
      return null;
    });
    this.setState({
      inspectionTypesAccordion: accordion,
    });
  };

  setLookupData = () => {
    var obj = this.state.contractingTypes.reduce(function (acc: any, cur, i) {
      acc[cur.id] = cur.name;
      return acc;
    }, {});
    this.setState({
      lookupData: obj,
    });
  };
  downloadQuestionAsset = (imageItem: any) => {
    let assetsService: AssetsService = new AssetsService();
    this.setState({
      isLoading: true,
    });
    assetsService.getAsset(imageItem.filename).then((resp) => {
      this.setState({
        isLoading: false,
      });
      if (resp && resp.success && resp.data) {
        imageItem.base64 = resp.data;
        this.setState({ selectedImageItem: imageItem });
      }
    });
  };
  handleChange = (item: any) => {
    let accordion = this.state.inspectionTypesAccordion;
    let newAccordio = new Array<any>();
    accordion.map((mItem: any) => {
      if (mItem.title === item.title) {
        mItem.expanded = !item.expanded;
      } else {
        mItem.expanded = false;
      }
      newAccordio.push(mItem);
      return null;
    });
    this.setState({
      inspectionTypesAccordion: newAccordio,
    });
  };
  renderTextInput = (
    id: any,
    value: any,
    handleChange: any,
    handleBlur: any,
    name: any,
    label: any,
    error: any,
    setFieldValue: any,
    setFieldError: any,
    style?: any
  ) => {
    return (
      <TextField
        error={error ? true : false}
        style={style ? style : { margin: 10 }}
        id={id}
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        name={name}
        label={label}
        fullWidth
        helperText={error}
      />
    );
  };
  renderSelectTextInput = (
    selections: any,
    id: any,
    value: any,
    handleChange: any,
    handleBlur: any,
    name: any,
    label: any,
    error: any,
    setFieldValue: any,
    setFieldError: any,
    style?: any
  ) => {
    return (
      <div style={style ? style : { margin: 10 }}>
        <FormControl fullWidth>
          <InputLabel id="province">Province</InputLabel>
          <Select
            key={value}
            value={value ? value.value : ""}
            labelId="province"
            id="province"
            name="province"
            onChange={(event) => {
              let province = getInspectionLabel(event.target.value, selections);
              setFieldValue("province", province);
            }}
            onBlur={handleBlur}
            label="Province"
          >
            {selections.map((option: any) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        {/* <TextField
          select
          id={id}
          label={label}
          value={value ? value : ""}
          onChange={handleChange(id)}
          fullWidth
        >
          {selections.map((option: any) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
        <Typography
          variant={"subtitle1"}
          align={"right"}
          style={{
            color: "red",
            alignSelf: "right"
          }}
        >
          {error}
        </Typography> */}
      </div>
    );
  };

  onDepartmentAddClicked = () => {
    if (this.state.departmentValue) {
      let currentDepartments = this.state.departments;
      currentDepartments.push(this.state.departmentValue);
      this.setState({
        departments: currentDepartments,
        departmentValue: { value: "", title: "" },
      });
    }
  };
  onSectionAddClicked = () => {
    if (this.state.sectionValue) {
      let currentSections = this.state.sections;
      currentSections.push(this.state.sectionValue);
      this.setState({
        sections: currentSections,
        sectionValue: { value: "", title: "" },
      });
    }
  };
  onMachinineryAddClicked = () => {
    if (this.state.machinineryValue) {
      let currentMachinineryTypes = this.state.machinineryTypes;
      currentMachinineryTypes.push(this.state.machinineryValue);
      this.setState({
        machinineryTypes: currentMachinineryTypes,
        machinineryValue: { value: "", label: "" },
      });
    }
  };
  onOperationAddClicked = () => {
    if (this.state.operations) {
      let currentOperationTypes = this.state.operations;
      currentOperationTypes.push(this.state.operationValue);
      this.setState({
        operations: currentOperationTypes,
        operationValue: { value: "", label: "" },
      });
    }
  };
  onShiftAddClicked = () => {
    if (this.state.shifts) {
      let currentShiftTypes = this.state.shifts;
      currentShiftTypes.push(this.state.shiftValue);
      this.setState({
        shifts: currentShiftTypes,
        shiftValue: { value: "", label: "", startOfShift: "", endOfShift: "" },
      });
    }
  };
  onInspectionTypeAddClicked = (mItem: any) => {
    let currentInspections = this.state.inspectionTypes;
    currentInspections.push(mItem);
    this.setState(
      {
        inspectionTypes: currentInspections,
        selectedInspectionType: -1,
        addCategory: false,
        inspectionTypeValue: {
          value: "",
          label: "",
          categories: new Array<any>(),
        },
      },
      () => {
        this.setUpInspectionTypesAccordion();
      }
    );
  };

  onContractingTypesAddClicked = () => {
    if (this.state.contractingTypeValue) {
      let currentContractingTypes = this.state.contractingTypes;
      let currentValue = this.state.contractingTypeValue;
      currentValue.id = Math.floor(Math.random() * (1000 - 1) + 1);
      currentContractingTypes.push(currentValue);
      var obj = currentContractingTypes.reduce(function (acc: any, cur, i) {
        acc[cur.id] = cur.name;
        return acc;
      }, {});
      this.setState(
        {
          lookupData: {},
        },
        () => {
          this.setState({
            contractingTypes: currentContractingTypes,
            lookupData: obj,
            contractingTypeValue: { id: -1, name: "" },
          });
        }
      );
    }
  };

  onPositionAddClicked = () => {
    if (this.state.positionValue) {
      let currentPositions = this.state.positions;
      currentPositions.push(this.state.positionValue);
      this.setState({
        positions: currentPositions,
        positionValue: { value: "", label: "" },
      });
    }
  };
  onActivityFlowLegendsAddClicked = () => {
    if (this.state.activityFlowLegendsValue) {
      let currentActivityFlowLegends = this.state.activityFlowLegends;
      currentActivityFlowLegends.push(this.state.activityFlowLegendsValue);
      this.setState({
        activityFlowLegends: currentActivityFlowLegends,
        activityFlowLegendsValue: { code: "", definition: "" },
      });
    }
  };

  onFrequencyAddClicked = () => {
    if (this.state.inspectionFrequencyValue) {
      let currentInspectionFrequencies = this.state.inspectionFrequencies;
      currentInspectionFrequencies.push(this.state.inspectionFrequencyValue);
      this.setState({
        inspectionFrequencies: currentInspectionFrequencies,
        inspectionFrequencyValue: { value: "", label: "" },
      });
    }
  };

  handleRemoveFrequencyChip = (item: any, index: any) => {
    let items = [...this.state.inspectionFrequencies];
    items.splice(index, 1);
    this.setState({
      inspectionFrequencies: items,
    });
  };

  handleRemoveDepartmentChip = (item: any, index: any) => {
    let items = [...this.state.departments];
    items.splice(index, 1);
    this.setState({
      departments: items,
    });
  };
  handleRemoveContractingTypesChip = (item: any, index: any) => {
    let items = [...this.state.contractingTypes];
    items.splice(index, 1);
    this.setState({
      contractingTypes: items,
    });
  };
  handleRemoveSectionChip = (item: any, index: any) => {
    let items = [...this.state.sections];
    items.splice(index, 1);
    this.setState({
      sections: items,
    });
  };
  handleRemoveMachineryChip = (item: any, index: any) => {
    let items = [...this.state.machinineryTypes];
    items.splice(index, 1);
    this.setState({
      machinineryTypes: items,
    });
  };
  handleRemoveOperationChip = (item: any, index: any) => {
    let items = [...this.state.operations];
    items.splice(index, 1);
    this.setState({
      operations: items,
    });
  };
  handleRemoveShiftChip = (item: any, index: any) => {
    let items = [...this.state.shifts];
    items.splice(index, 1);
    this.setState({
      shifts: items,
    });
  };
  handleRemoveInspectionTypeChip = (item: any, index: any) => {
    let items = [...this.state.inspectionTypes];
    items.splice(index, 1);
    this.setState({
      inspectionTypes: items,
    });
  };
  handleActivityFlowLengendTypeChip = (item: any, index: any) => {
    let items = [...this.state.activityFlowLegends];
    items.splice(index, 1);
    this.setState({
      activityFlowLegends: items,
    });
  };
  handleRemovePositionChip = (item: any, index: any) => {
    let items = [...this.state.positions];
    items.splice(index, 1);
    this.setState({
      positions: items,
    });
  };
  handleRemoveActivityLegndsChip = (item: any, index: any) => {
    let items = [...this.state.activityFlowLegends];
    items.splice(index, 1);
    this.setState({
      activityFlowLegends: items,
    });
  };
  handleOnOpenRenderImages = () => {
    this.setState({
      openRenderImagesDialog: true,
    });
  };
  handleOnImageSelected = (imageItem: any) => {
    this.setState({
      openRenderImagesDialog: false,
      selectedImageItem: imageItem,
    });
  };

  handleRemoveInspectionTypes = () => {
    let index = this.state.selectedInspectionTypeIndex;
    let items = [...this.state.inspectionTypes];
    items.splice(index, 1);
    this.setState(
      {
        inspectionTypes: items,
        selectedInspectionTypeIndex: -1,
      },
      () => {
        this.setUpInspectionTypesAccordion();
      }
    );
  };

  handleRemoveScheduler = () => {
    let index = this.state.selectedSchedulerIndex;
    let items = [...this.state.schedules];
    items.splice(index, 1);
    this.setState({
      schedules: items,
      selectedSchedulerIndex: -1,
      openSchedulerConfimDelete: false,
    });
  };

  renderImagesDialog = () => {
    return (
      <RenderImagesDialog
        open={this.state.openRenderImagesDialog}
        companyData={this.props.companyData}
        onClose={() => {
          this.setState({
            openRenderImagesDialog: false,
          });
        }}
        onSelectedItem={this.handleOnImageSelected}
        dialogTitle={"Choose Image"}
        images={[]}
      />
    );
  };
  renderConfirmationDialog = () => {
    if (this.state.selectedInspectionTypeIndex < 0) {
      return;
    }
    let inspectionType =
      this.state.inspectionTypes[this.state.selectedInspectionTypeIndex];
    if (!inspectionType) {
      return;
    }
    return (
      <Dialog
        fullWidth={true}
        open={this.state.openConfimDelete}
        onClose={() =>
          this.setState({
            openConfimDelete: false,
            selectedInspectionTypeIndex: -1,
          })
        }
      >
        <DialogTitle id="alert-dialog-title">
          {`Deleting ${inspectionType.label}`}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {`Are you sure want to delete this inspection type.`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() =>
              this.setState({
                openConfimDelete: false,
                selectedInspectionTypeIndex: -1,
              })
            }
            color="primary"
          >
            No
          </Button>
          <Button
            onClick={() => this.handleRemoveInspectionTypes()}
            color="primary"
            autoFocus
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    );
  };
  renderSchedulerConfirmationDialog = () => {
    if (this.state.selectedSchedulerIndex < 0) {
      return;
    }
    let scheduler = this.state.schedules[this.state.selectedSchedulerIndex];
    if (!scheduler) {
      return;
    }
    return (
      <Dialog
        fullWidth={true}
        open={this.state.openSchedulerConfimDelete}
        onClose={() =>
          this.setState({
            openSchedulerConfimDelete: false,
            selectedSchedulerIndex: -1,
          })
        }
      >
        <DialogTitle id="alert-dialog-title">{`Deleting Schedule`}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {`Are you sure want to delete this schedule.`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() =>
              this.setState({
                openSchedulerConfimDelete: false,
                selectedSchedulerIndex: -1,
              })
            }
            color="primary"
          >
            No
          </Button>
          <Button
            onClick={() => this.handleRemoveScheduler()}
            color="primary"
            autoFocus
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    );
  };
  onCategoryAdded = (mItem: any) => {
    if (this.state.selectedInspectionTypeIndex > -1) {
      let inspectionTypes = this.state.inspectionTypes;
      inspectionTypes.splice(this.state.selectedInspectionTypeIndex, 1, mItem);
      this.setState(
        {
          selectedInspectionTypeIndex: -1,
          addCategory: false,
          inspectionTypes: inspectionTypes,
          inspectionTypeValue: {
            value: "",
            label: "",
            categories: new Array<any>(),
          },
        },
        () => {
          this.setUpInspectionTypesAccordion();
        }
      );
    } else {
      this.onInspectionTypeAddClicked(mItem);
    }
  };
  onSchedulerSubmitted = (schedulerValues: any) => {
    let schedules = this.state.schedules;
    if (this.state.selectedSchedulerIndex > -1) {
      schedules.splice(this.state.selectedSchedulerIndex, 1, schedulerValues);
      this.setState({
        schedules: schedules,
        selectedSchedulerIndex: -1,
        selectedScheduler: {},
        openScheduleDialog: false,
      });
    } else {
      schedules.push(schedulerValues);
      this.setState({
        schedules: schedules,
        openScheduleDialog: false,
      });
    }
  };
  renderAddCategoryDialog = () => {
    return (
      <AddInspectionCategoryDialog
        open={this.state.addCategory}
        onClose={() => {
          this.setState({
            addCategory: false,
            selectedInspectionTypeIndex: -1,
            inspectionTypeValue: {
              value: "",
              label: "",
              categories: new Array<any>(),
            },
          });
        }}
        inspectionType={
          this.state.selectedInspectionTypeIndex > -1
            ? this.state.inspectionTypes[this.state.selectedInspectionTypeIndex]
            : this.state.inspectionTypeValue
        }
        onCategoryAdded={this.onCategoryAdded}
        dialogTitle={`Add Inspection Category for: ${
          this.state.selectedInspectionTypeIndex > -1
            ? this.state.inspectionTypes[this.state.selectedInspectionTypeIndex]
                .label
            : this.state.inspectionTypeValue.label
        }`}
      />
    );
  };
  renderAddScheduleDialog = () => {
    const { companyData } = this.props;
    return (
      <AddScheduleDialog
        open={this.state.openScheduleDialog}
        onClose={() => {
          this.setState({
            openScheduleDialog: false,
            selectedSchedulerIndex: -1,
            selectedScheduler: {},
          });
        }}
        editData={
          this.state.selectedSchedulerIndex > -1
            ? this.state.selectedScheduler
            : {}
        }
        companyData={companyData}
        onSchedulerSubmitted={this.onSchedulerSubmitted}
        dialogTitle={`Add Scheduler`}
      />
    );
  };
  renderCompanyDetailsField = (
    values: any,
    handleChange: any,
    handleBlur: any,
    errors: any,
    setFieldValue: any,
    setFieldError: any
  ) => {
    let { classes, companyData } = this.props;
    return (
      <div style={{ display: "flex", flexDirection: "row", flex: 1 }}>
        <div style={{ display: "flex", flexDirection: "row", flex: 0.4 }}>
          {companyData && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <ButtonBase className={classes.image}>
                {this.state.selectedImageItem.base64 &&
                !isEmpty(this.state.selectedImageItem.base64) ? (
                  <img
                    className={classes.img}
                    alt="complex"
                    src={`data:image/jpeg;base64,${this.state.selectedImageItem.base64}`}
                  />
                ) : (
                  <img
                    className={classes.img}
                    alt="complex"
                    src={imagePlacholder}
                  />
                )}
              </ButtonBase>

              <Paper
                elevation={3}
                style={{
                  width: "100%",
                  height: 50,
                  margin: 10,
                  alignSelf: "center",
                  justifyContent: "center",
                  alignItems: "center",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Button
                  size="small"
                  style={{
                    backgroundColor: "white",
                    color: "grey",
                    borderColor: "grey",
                    borderWidth: 1,
                    height: 48,
                    width: "100%",
                  }}
                  onClick={() => this.handleOnOpenRenderImages()}
                  startIcon={<CloudUploadIcon />}
                >
                  Upload
                </Button>
              </Paper>
            </div>
          )}
        </div>
        <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
          {this.renderTextInput(
            "name",
            values.name,
            handleChange,
            handleBlur,
            "name",
            "Company Name",
            errors.name,
            setFieldValue,
            setFieldError
          )}
          {this.renderTextInput(
            "email",
            values.email,
            handleChange,
            handleBlur,
            "email",
            "Email",
            errors.email,
            setFieldValue,
            setFieldError
          )}
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              flexWrap: "wrap",
              margin: 10,
              justifyContent: "space-betwen",
            }}
          >
            {this.renderTextInput(
              "line1",
              values.line1,
              handleChange,
              handleBlur,
              "line1",
              "Address Line 1",
              errors.line1,
              setFieldValue,
              setFieldError,
              { width: "50%", padding: 5 }
            )}
            {this.renderTextInput(
              "line2",
              values.line2,
              handleChange,
              handleBlur,
              "line2",
              "Address Line 2",
              errors.line2,
              setFieldValue,
              setFieldError,
              { width: "50%", padding: 5 }
            )}
            {this.renderTextInput(
              "city",
              values.city,
              handleChange,
              handleBlur,
              "city",
              "City",
              errors.city,
              setFieldValue,
              setFieldError,
              { width: "50%", padding: 5 }
            )}
            {this.renderSelectTextInput(
              PROVINCES,
              "province",
              values.province,
              handleChange,
              handleBlur,
              "Province",
              "Province",
              errors.province,
              setFieldValue,
              setFieldError,
              { width: "50%", padding: 5 }
            )}
            {this.renderTextInput(
              "postalCode",
              values.postalCode,
              handleChange,
              handleBlur,
              "postalCode",
              "Postal Code",
              errors.postalCode,
              setFieldValue,
              setFieldError,
              { width: "50%", padding: 5 }
            )}
            {this.renderTextInput(
              "phone",
              values.phone,
              handleChange,
              handleBlur,
              "phone",
              "Phone Number",
              errors.phone,
              setFieldValue,
              setFieldError
            )}
          </div>
        </div>
      </div>
    );
  };
  renderOperationsField = (
    values: any,
    handleChange: any,
    handleBlur: any,
    errors: any,
    setFieldValue: any,
    setFieldError: any
  ) => {
    return (
      <div>
        <div
          style={{
            margin: 10,
            display: "flex",
            alignItems: "center",
          }}
        >
          <TextField
            fullWidth
            id="standard-basic"
            label="Departments"
            value={this.state.departmentValue.title}
            placeholder="Add Deparments"
            onChange={(event: any) => {
              let currentDepartmentValue = this.state.departmentValue;
              currentDepartmentValue.value = event.target.value.toUpperCase();
              currentDepartmentValue.title = event.target.value;
              this.setState({
                departmentValue: currentDepartmentValue,
              });
            }}
          />
          <Button
            variant="outlined"
            disabled={
              this.state.departmentValue &&
              this.state.departmentValue.title &&
              this.state.departmentValue.value
                ? false
                : true
            }
            onClick={() => this.onDepartmentAddClicked()}
            style={{ marginLeft: 20 }}
          >
            ADD
          </Button>
        </div>
        {this.state.departments.map((item: any, index: number) => {
          return (
            <ChipComponent
              key={`chip-depart:${index.toString()}`}
              title={item.title}
              item={item}
              index={index}
              isDisabled={this.state.departmentValue.title ? true : false}
              chipValue={this.state.departmentValue}
              onChipDelete={(mItem: any, nIndex: any) => {
                this.handleRemoveDepartmentChip(mItem, nIndex);
              }}
              onChipEdit={(mItem: any, nIndex: any) => {
                let departments = this.state.departments;
                departments.splice(nIndex, 1, mItem);
                this.setState({
                  departments: departments,
                });
              }}
            />
          );
        })}
        <div
          style={{
            margin: 10,
            display: "flex",
            alignItems: "center",
          }}
        >
          <TextField
            fullWidth
            id="standard-basic"
            label="Section"
            value={this.state.sectionValue.title}
            placeholder="Add Sections"
            onChange={(event: any) => {
              let currentSectionValue = this.state.sectionValue;
              currentSectionValue.value = event.target.value.toUpperCase();
              currentSectionValue.title = event.target.value;
              this.setState({
                sectionValue: currentSectionValue,
              });
            }}
          />
          <Button
            variant="outlined"
            disabled={
              this.state.sectionValue &&
              this.state.sectionValue.title &&
              this.state.sectionValue.value
                ? false
                : true
            }
            onClick={() => this.onSectionAddClicked()}
            style={{ marginLeft: 20 }}
          >
            ADD
          </Button>
        </div>
        {this.state.sections.map((item: any, index: number) => {
          return (
            <ChipComponent
              key={`chip-depart:${index.toString()}`}
              title={item.title}
              item={item}
              index={index}
              chipValue={this.state.sectionValue}
              isDisabled={this.state.sectionValue.title ? true : false}
              onChipDelete={(mItem: any, nIndex: any) => {
                this.handleRemoveSectionChip(mItem, nIndex);
              }}
              onChipEdit={(mItem: any, nIndex: any) => {
                let sections = this.state.sections;
                sections.splice(nIndex, 1, mItem);
                this.setState({
                  sections: sections,
                });
              }}
            />
          );
        })}
        <div
          style={{
            margin: 10,
            display: "flex",
            alignItems: "center",
          }}
        >
          <TextField
            fullWidth
            id="standard-basic"
            label="Machininery Type"
            value={this.state.machinineryValue.label}
            placeholder="Add Machininery Type"
            onChange={(event: any) => {
              let currentMachinineryValue = this.state.machinineryValue;
              currentMachinineryValue.value = event.target.value.toUpperCase();
              currentMachinineryValue.label = event.target.value;
              this.setState({
                machinineryValue: currentMachinineryValue,
              });
            }}
          />
          <Button
            variant="outlined"
            disabled={
              this.state.machinineryValue &&
              this.state.machinineryValue.label &&
              this.state.machinineryValue.value
                ? false
                : true
            }
            onClick={() => this.onMachinineryAddClicked()}
            style={{ marginLeft: 20 }}
          >
            ADD
          </Button>
        </div>
        {this.state.machinineryTypes.map((item: any, index: number) => {
          return (
            <ChipComponent
              key={`chip-depart:${index.toString()}`}
              title={item.label}
              item={item}
              index={index}
              chipValue={this.state.machinineryValue}
              isDisabled={this.state.machinineryValue.label ? true : false}
              onChipDelete={(mItem: any, nIndex: any) => {
                this.handleRemoveMachineryChip(mItem, nIndex);
              }}
              onChipEdit={(mItem: any, nIndex: any) => {
                let machinineryTypes = this.state.machinineryTypes;
                machinineryTypes.splice(nIndex, 1, mItem);
                this.setState({
                  machinineryTypes: machinineryTypes,
                });
              }}
            />
          );
        })}

        <div
          style={{
            margin: 10,
            display: "flex",
            alignItems: "center",
          }}
        >
          <TextField
            fullWidth
            id="standard-basic"
            label="Operations"
            value={this.state.operationValue.label}
            placeholder="Add Operations"
            onChange={(event: any) => {
              let currentOperationValue = this.state.operationValue;
              currentOperationValue.value = event.target.value.toUpperCase();
              currentOperationValue.label = event.target.value;
              this.setState({
                operationValue: currentOperationValue,
              });
            }}
          />
          <Button
            variant="outlined"
            disabled={
              this.state.operationValue &&
              this.state.operationValue.label &&
              this.state.operationValue.value
                ? false
                : true
            }
            onClick={() => this.onOperationAddClicked()}
            style={{ marginLeft: 20 }}
          >
            ADD
          </Button>
        </div>
        {this.state.operations.map((item: any, index: number) => {
          return (
            <ChipComponent
              key={`chip-depart:${index.toString()}`}
              title={item.label}
              item={item}
              index={index}
              chipValue={this.state.operationValue}
              isDisabled={this.state.machinineryValue.label ? true : false}
              onChipDelete={(mItem: any, nIndex: any) => {
                this.handleRemoveOperationChip(mItem, nIndex);
              }}
              onChipEdit={(mItem: any, nIndex: any) => {
                let operations = this.state.operations;
                operations.splice(nIndex, 1, mItem);
                this.setState({
                  operations: operations,
                });
              }}
            />
          );
        })}
        <div
          style={{
            margin: 10,
            display: "flex",
            alignItems: "center",
          }}
        >
          <TextField
            fullWidth
            id="standard-basic"
            label="Shift"
            value={this.state.shiftValue.label}
            placeholder="Add Shfits"
            onChange={(event: any) => {
              let currentShiftValue = this.state.shiftValue;
              currentShiftValue.value = event.target.value.includes("")
                ? event.target.value.toUpperCase()
                : event.target.value
                    .replace(" ", "-".toUpperCase())
                    .toUpperCase();
              currentShiftValue.label = event.target.value;
              this.setState({
                shiftValue: currentShiftValue,
              });
            }}
          />
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Grid container justify="space-around">
              <TimePicker
                fullWidth
                id="time-picker"
                label="Start of Shift"
                value={moment(
                  this.state.shiftValue.startOfShift
                    ? this.state.shiftValue.startOfShift
                    : new Date(),
                  "HH:mm"
                )}
                onChange={(time: any) => {
                  let timeMoment = moment(new Date(time), "HH:mm");
                  let currentShiftValue = this.state.shiftValue;
                  if (time) {
                    currentShiftValue.startOfShift = timeMoment
                      .format("HH:mm")
                      .toString();
                  }
                  this.setState({
                    shiftValue: currentShiftValue,
                  });
                }}
              />
            </Grid>
            <Grid container justify="space-around">
              <TimePicker
                fullWidth
                id="time-picker"
                label="End of Shift"
                disabled={
                  this.state.shiftValue && this.state.shiftValue.startOfShift
                    ? false
                    : true
                }
                value={moment(
                  this.state.shiftValue.endOfShift
                    ? this.state.shiftValue.endOfShift
                    : new Date(),
                  "HH:mm"
                )}
                onChange={(time: any) => {
                  let newDate = new Date(time);
                  let timeMoment = moment({
                    h: newDate.getHours(),
                    m: newDate.getMinutes(),
                  });
                  let currentShiftValue = this.state.shiftValue;
                  if (time) {
                    let _time = timeMoment.format("HH:mm").toString();
                    if (currentShiftValue.startOfShift) {
                      currentShiftValue.endOfShift = _time;
                      this.setState({
                        shiftValue: currentShiftValue,
                      });
                    }
                  }
                  this.setState({
                    shiftValue: currentShiftValue,
                  });
                }}
              />
            </Grid>
          </MuiPickersUtilsProvider>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              marginLeft: 20,
              justifyContent: "space-evenly",
            }}
          >
            <Button
              variant="outlined"
              disabled={
                this.state.shiftValue &&
                this.state.shiftValue.value &&
                this.state.shiftValue.label &&
                this.state.shiftValue.startOfShift &&
                this.state.shiftValue.endOfShift
                  ? false
                  : true
              }
              onClick={() => {
                if (this.state.nIndexShiftValueSelected > -1) {
                  let shifts = this.state.shifts;
                  let mItem = this.state.shiftValue;
                  shifts.splice(this.state.nIndexShiftValueSelected, 1, mItem);
                  this.setState({
                    shifts: shifts,
                    shiftValue: {
                      value: "",
                      label: "",
                      startOfShift: "",
                      endOfShift: "",
                    },
                    nIndexShiftValueSelected: -1,
                  });
                } else {
                  this.onShiftAddClicked();
                }
              }}
            >
              {this.state.nIndexShiftValueSelected > -1 ? "SAVE" : "ADD"}
            </Button>
            {this.state.nIndexShiftValueSelected > -1 && (
              <Button
                variant="outlined"
                style={{ marginLeft: 10 }}
                onClick={() => {
                  this.setState({
                    shiftValue: {
                      value: "",
                      label: "",
                      startOfShift: "",
                      endOfShift: "",
                    },
                    nIndexShiftValueSelected: -1,
                  });
                }}
              >
                Cancel
              </Button>
            )}
          </div>
        </div>
        <Typography
          style={{
            marginLeft: 10,
            color: "red",
            opacity: this.state.timeCaptureError ? 1 : 0,
          }}
        >
          {this.state.timeCaptureError}
        </Typography>
        {this.state.shifts.map((item: any, index: number) => {
          return (
            <ChipComponent
              key={`chip-depart:${index.toString()}`}
              title={item.label}
              item={item}
              index={index}
              chipValue={this.state.shiftValue}
              isDisabled={this.state.shiftValue.label ? true : false}
              onChipDelete={(mItem: any, nIndex: any) => {
                this.handleRemoveShiftChip(mItem, nIndex);
              }}
              ownEditDialog={(mItem: any, nIndex: any) => {
                let currentShiftValue = this.state.shiftValue;
                currentShiftValue.label = mItem.label;
                currentShiftValue.value = mItem.value
                  ? mItem.value
                  : mItem.label.includes("")
                  ? mItem.label.toUpperCase()
                  : mItem.label.replace(" ", "-".toUpperCase()).toUpperCase();
                currentShiftValue.startOfShift = mItem.startOfShift;
                currentShiftValue.endOfShift = mItem.endOfShift;
                this.setState({
                  shiftValue: currentShiftValue,
                  nIndexShiftValueSelected: nIndex,
                });
              }}
              onChipEdit={(mItem: any, nIndex: any) => {
                let shifts = this.state.shifts;
                shifts.splice(nIndex, 1, mItem);
                this.setState({
                  shifts: shifts,
                });
              }}
            />
          );
        })}
        <div
          style={{
            display: "flex",
            margin: 10,
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <TextField
            fullWidth
            id="standard-basic"
            label="Position"
            value={this.state.positionValue.label}
            placeholder="Add Position"
            onChange={(event: any) => {
              let currentPositionValue = this.state.positionValue;
              currentPositionValue.value = event.target.value.toUpperCase();
              currentPositionValue.label = event.target.value;
              this.setState({
                positionValue: currentPositionValue,
              });
            }}
          />
          <Button
            variant="outlined"
            disabled={
              this.state.positionValue &&
              this.state.positionValue.label &&
              this.state.positionValue.value
                ? false
                : true
            }
            onClick={() => this.onPositionAddClicked()}
            style={{ marginLeft: 20 }}
          >
            ADD
          </Button>
        </div>
        {this.state.positions.map((item: any, index: number) => {
          return (
            <ChipComponent
              key={`chip-pos:${index.toString()}`}
              title={item.label}
              item={item}
              index={index}
              chipValue={this.state.positionValue}
              isDisabled={this.state.positionValue.label ? true : false}
              onChipDelete={(mItem: any, nIndex: any) => {
                this.handleRemovePositionChip(mItem, nIndex);
              }}
              onChipEdit={(mItem: any, nIndex: any) => {
                let positions = this.state.positions;
                positions.splice(nIndex, 1, mItem);
                this.setState({
                  positions: positions,
                });
              }}
            />
          );
        })}
      </div>
    );
  };
  renderInspectionField = (
    values: any,
    handleChange: any,
    handleBlur: any,
    errors: any,
    setFieldValue: any,
    setFieldError: any
  ) => {
    const { classes } = this.props;
    console.log(this.state.workflows);
    return (
      <div>
        <FormControlLabel
          control={
            <CustomChecked
              checked={this.state.workflows}
              onChange={(event) => {
                this.setState({
                  workflows: event.target.checked,
                });
              }}
              name="workflows"
              style={{ margin: 10 }}
            />
          }
          label="Do you have Workflows in your Company?"
        />
        <div
          style={{
            display: "flex",
            margin: 10,
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <TextField
            fullWidth
            id="standard-basic"
            label="Inspection Types"
            value={this.state.inspectionTypeValue.label}
            placeholder="Add Inspection type"
            onChange={(event: any) => {
              let currentInspectionTypeValue = this.state.inspectionTypeValue;
              currentInspectionTypeValue.value = event.target.value.includes(
                "-"
              )
                ? event.target.value.toUpperCase()
                : event.target.value.replace(" ", "-").toUpperCase();
              currentInspectionTypeValue.label = event.target.value;
              this.setState({
                inspectionTypeValue: currentInspectionTypeValue,
              });
            }}
          />
          <Button
            variant="outlined"
            disabled={
              this.state.inspectionTypeValue &&
              this.state.inspectionTypeValue.label &&
              this.state.inspectionTypeValue.value
                ? false
                : true
            }
            onClick={() =>
              this.setState({
                addCategory: true,
                selectedInspectionTypeIndex: -1,
              })
            }
            style={{ marginLeft: 20 }}
          >
            ADD
          </Button>
        </div>
        <List>
          {this.state.inspectionTypesAccordion.map((item: any, index: any) => {
            return (
              <Accordion
                key={index.toString()}
                expanded={item.expanded}
                onChange={() => this.handleChange(item)}
              >
                <div
                  style={{
                    flex: 1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    flexDirection: "row",
                  }}
                >
                  <AccordionSummary
                    style={{ flex: 1 }}
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                  >
                    <Typography className={classes.heading}>
                      {item.title}
                    </Typography>

                    <Typography className={classes.secondaryHeading}>
                      {`Categories (${
                        item.categories ? item.categories.length : 0
                      })`}
                    </Typography>
                  </AccordionSummary>
                  <IconButton
                    style={{
                      width: 15,
                      height: 15,
                      marginRight: 10,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    onClick={() =>
                      this.setState({
                        selectedInspectionTypeIndex: index,
                        inspectionTypeValue: this.state.inspectionTypes[index],
                        addCategory: true,
                      })
                    }
                  >
                    <EditIcon
                      style={{
                        width: 15,
                        height: 15,
                      }}
                      fontSize={"small"}
                    />
                  </IconButton>
                  <IconButton
                    style={{
                      width: 15,
                      height: 15,
                      marginRight: 10,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    onClick={() =>
                      this.setState({
                        selectedInspectionTypeIndex: index,
                        openConfimDelete: true,
                      })
                    }
                  >
                    <DeleteIcon
                      style={{
                        width: 15,
                        height: 15,
                      }}
                      fontSize={"small"}
                    />
                  </IconButton>
                </div>

                <Divider variant={"inset"} />
                {item.categories && (
                  <AccordionDetails>
                    <List style={{ width: "100%" }}>
                      {item.categories.map((category: any, index: any) => (
                        <ListItem key={index.toString()} divider={true}>
                          <ListItemText primary={category.label} />
                        </ListItem>
                      ))}
                    </List>
                  </AccordionDetails>
                )}
              </Accordion>
            );
          })}
        </List>
        <div
          style={{
            margin: 10,
            display: "flex",

            justifyContent: "space-evenly",
            alignItems: "center",
          }}
        >
          <TextField
            id="standard-basic"
            label="Activity Code"
            inputProps={{
              maxLength: 1,
            }}
            value={this.state.activityFlowLegendsValue.code}
            placeholder="Add Activity Code"
            onChange={(event: any) => {
              let currentActivityFlowLegendsValue =
                this.state.activityFlowLegendsValue;
              currentActivityFlowLegendsValue.code = event.target.value;
              this.setState({
                activityFlowLegendsValue: currentActivityFlowLegendsValue,
              });
            }}
            style={{ marginRight: 5, flex: 0.3 }}
          />
          <TextField
            id="standard-basic"
            label="Activity Definition"
            value={this.state.activityFlowLegendsValue.definition}
            placeholder="Add Activity Definition"
            onChange={(event: any) => {
              let currentActivityFlowLegendsValue =
                this.state.activityFlowLegendsValue;
              currentActivityFlowLegendsValue.definition = event.target.value;
              this.setState({
                activityFlowLegendsValue: currentActivityFlowLegendsValue,
              });
            }}
            style={{ flex: 0.7 }}
          />
          <div
            style={{ display: "flex", flexDirection: "row", marginLeft: 20 }}
          >
            <Button
              variant="outlined"
              disabled={
                this.state.activityFlowLegendsValue &&
                this.state.activityFlowLegendsValue.code &&
                this.state.activityFlowLegendsValue.definition
                  ? false
                  : true
              }
              onClick={() => {
                if (this.state.nIndexActivityFlowLegendsValueSelected > -1) {
                  let activityFlowLegends = this.state.activityFlowLegends;
                  let mItem = this.state.activityFlowLegendsValue;
                  activityFlowLegends.splice(
                    this.state.nIndexActivityFlowLegendsValueSelected,
                    1,
                    mItem
                  );
                  this.setState({
                    activityFlowLegends: activityFlowLegends,
                    activityFlowLegendsValue: { code: "", definition: "" },
                    nIndexActivityFlowLegendsValueSelected: -1,
                  });
                } else {
                  this.onActivityFlowLegendsAddClicked();
                }
              }}
            >
              {this.state.nIndexActivityFlowLegendsValueSelected > -1
                ? "SAVE"
                : "ADD"}
            </Button>
            {this.state.nIndexActivityFlowLegendsValueSelected > -1 && (
              <Button
                variant="outlined"
                style={{ marginLeft: 10 }}
                onClick={() => {
                  this.setState({
                    activityFlowLegendsValue: { code: "", definition: "" },
                    nIndexActivityFlowLegendsValueSelected: -1,
                  });
                }}
              >
                Cancel
              </Button>
            )}
          </div>
        </div>
        {this.state.activityFlowLegends.map((item: any, index: number) => {
          return (
            <ChipComponent
              key={`chip-depart:${index.toString()}`}
              title={
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  <Typography
                    style={{ marginLeft: 5, marginRight: 5 }}
                  >{`(${item.code})`}</Typography>
                  <Typography>{item.definition}</Typography>
                </div>
              }
              subTitle={`(${item.code}) ${item.definition}`}
              item={item}
              index={index}
              chipValue={this.state.activityFlowLegendsValue}
              isDisabled={
                this.state.activityFlowLegendsValue.code ? true : false
              }
              onChipDelete={(mItem: any, nIndex: any) => {
                this.handleActivityFlowLengendTypeChip(mItem, nIndex);
              }}
              ownEditDialog={(mItem: any, nIndex: any) => {
                let activityFlowLegendsValue =
                  this.state.activityFlowLegendsValue;
                activityFlowLegendsValue.code = mItem.code;
                activityFlowLegendsValue.definition = mItem.definition;
                this.setState({
                  activityFlowLegendsValue: activityFlowLegendsValue,
                  nIndexActivityFlowLegendsValueSelected: nIndex,
                });
              }}
              onChipEdit={(mItem: any, nIndex: any) => {
                let activityFlowLegends = this.state.activityFlowLegends;
                activityFlowLegends.splice(nIndex, 1, mItem);
                this.setState({
                  activityFlowLegends: activityFlowLegends,
                });
              }}
            />
          );
        })}
        <div
          style={{
            margin: 10,
            width: "100%",
            display: "flex",
          }}
        >
          <TextField
            id="standard-basic"
            label="Inspection Frequency"
            value={this.state.inspectionFrequencyValue.label}
            placeholder="Add Frequency"
            onChange={(event: any) => {
              let currentInspectionFrequencyValue =
                this.state.inspectionFrequencyValue;
              currentInspectionFrequencyValue.value =
                event.target.value.includes("-")
                  ? event.target.value.toUpperCase()
                  : event.target.value.replace(" ", "-").toUpperCase();
              currentInspectionFrequencyValue.label = event.target.value;
              this.setState({
                inspectionFrequencyValue: currentInspectionFrequencyValue,
              });
            }}
            style={{ width: "60%" }}
          />
          <Button
            variant="outlined"
            disabled={
              this.state.inspectionFrequencyValue &&
              this.state.inspectionFrequencyValue.label &&
              this.state.inspectionFrequencyValue.value
                ? false
                : true
            }
            style={{ marginLeft: 20 }}
            onClick={() => this.onFrequencyAddClicked()}
          >
            ADD
          </Button>
        </div>
        {this.state.inspectionFrequencies.map((item: any, index: number) => {
          return (
            <ChipComponent
              key={`chip-pos:${index.toString()}`}
              title={item.label}
              item={item}
              index={index}
              chipValue={this.state.inspectionFrequencyValue}
              isDisabled={
                this.state.inspectionFrequencyValue.label ? true : false
              }
              onChipDelete={(mItem: any, nIndex: any) => {
                this.handleRemoveFrequencyChip(mItem, nIndex);
              }}
              onChipEdit={(mItem: any, nIndex: any) => {
                let inspectionFrequencies = this.state.inspectionFrequencies;
                inspectionFrequencies.splice(nIndex, 1, mItem);
                this.setState({
                  inspectionFrequencies: inspectionFrequencies,
                });
              }}
            />
          );
        })}
      </div>
    );
  };

  renderSchedulingFields = (
    values: any,
    handleChange: any,
    handleBlur: any,
    errors: any,
    setFieldValue: any,
    setFieldError: any
  ) => {
    const { classes } = this.props;
    return (
      <div style={{ width: "100%" }}>
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            variant="outlined"
            style={{ marginLeft: 20 }}
            onClick={() =>
              this.setState({
                openScheduleDialog: true,
              })
            }
          >
            Add Schedule
          </Button>
        </div>
        <List className={classes.root}>
          {this.state.schedules.map((obj: any, index: any) => {
            let isStarted = moment(new Date()).isAfter(
              moment(new Date(obj.startDateTime))
            );
            return (
              <div key={`schudules-${index.toString()}`}>
                <div
                  style={{
                    width: "95%",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <ListItem>
                    <ListItemAvatar>
                      <IconButton
                        style={{
                          width: 30,
                          height: 30,
                        }}
                        onClick={() => {}}
                      >
                        <Avatar
                          style={{
                            backgroundColor: isStarted ? "green" : "orange",
                          }}
                        >
                          {isStarted ? <StopIcon /> : <PlayArrowIcon />}
                        </Avatar>
                      </IconButton>
                    </ListItemAvatar>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        width: "100%",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <ListItemText
                        primary={obj.inspectionType.label}
                        secondary={obj.category.label}
                      />
                      {convertToBoolean(obj.onceOff) ? (
                        <div
                          style={{
                            display: "flex",
                            marginRight: 20,
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <LooksOneIcon style={{ color: "grey" }} />
                          <Typography
                            variant="caption"
                            display="block"
                            gutterBottom
                          >
                            Once Off
                          </Typography>
                        </div>
                      ) : (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            marginRight: 20,
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <LoopIcon style={{ color: "grey" }} />
                          <Typography
                            variant="caption"
                            display="block"
                            gutterBottom
                          >
                            Recurring
                          </Typography>
                        </div>
                      )}
                    </div>
                  </ListItem>
                  <ListItem
                    style={{
                      alignSelf: "flex-end",
                      textAlign: "end",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <ListItemText
                      style={{
                        marginRight: 10,
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                      primary={
                        <ListItemText
                          primary={
                            isStarted ? (
                              <Badge color="secondary" variant="dot">
                                <Chip label={"Started"} variant={"outlined"} />
                              </Badge>
                            ) : (
                              "Starting on"
                            )
                          }
                          secondary={
                            isStarted
                              ? null
                              : getMomentDate(obj.startDateTime, "DD/MM/YYYY")
                          }
                          primaryTypographyProps={{
                            style: { fontWeight: "bold" },
                          }}
                          secondaryTypographyProps={{
                            style: { fontWeight: "bold" },
                          }}
                        />
                      }
                    />
                  </ListItem>
                  <ListItem
                    style={{
                      width: "5%",
                      marginLeft: 10,
                      alignSelf: "flex-end",
                      textAlign: "end",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <IconButton
                      aria-label="edit"
                      onClick={() => {
                        this.setState({
                          selectedScheduler: obj,
                          selectedSchedulerIndex: index,
                          openScheduleDialog: true,
                        });
                      }}
                    >
                      <EditIcon />
                    </IconButton>
                    <IconButton
                      aria-label="delete"
                      onClick={() => {
                        this.setState({
                          selectedScheduler: obj,
                          selectedSchedulerIndex: index,
                          openSchedulerConfimDelete: true,
                        });
                      }}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </ListItem>
                </div>
                <Divider variant={"inset"} />
              </div>
            );
          })}
        </List>
      </div>
    );
  };
  handleOnSubmit = (values: any) => {
    if (this.state.selectedImageItem && this.state.selectedImageItem.item) {
      values.imageItem = this.state.selectedImageItem.item;
    }
    values.departments = this.state.departments;
    values.sections = this.state.sections;
    values.inspectionTypes = this.state.inspectionTypes;
    values.workflows = this.state.workflows;
    values.activityFlowLegends = this.state.activityFlowLegends;
    values.machinineryTypes = this.state.machinineryTypes;
    values.operations = this.state.operations;
    values.shifts = this.state.shifts;
    values.positions = this.state.positions;
    values.contractors = this.state.contractors;
    values.contractingTypes = this.state.contractingTypes;
    values.inspectionFrequencies = this.state.inspectionFrequencies;
    values.schedules = this.state.schedules;
    if (this.props && this.props.handleOnSubmit) {
      this.props.handleOnSubmit(values);
    }
  };

  getInitialValues = () => {
    const { companyData } = this.props;
    if (companyData) {
      let initialValues = {
        name: companyData.name ? companyData.name : "",
        email: companyData.email ? companyData.email : "",
        line1: companyData.line1 ? companyData.line1 : "",
        line2: companyData.lin2 ? companyData.line2 : "",
        city: companyData.city ? companyData.city : "",
        workflows: companyData.workflows ? companyData.workflows : false,
        province: companyData.province ? companyData.province : "",
        postalCode: companyData.postalCode ? companyData.postalCode : "",
        phone: companyData.phone ? companyData.phone : "",
      };
      return initialValues;
    }
    return {
      name: "",
      email: "",
      line1: "",
      line2: "",
      city: "",
      workflows: false,
      province: "",
      postalCode: "",
      phone: "",
    };
  };

  onAddDataChanged = (newData: any) => {
    this.setState((prevState: any) => {
      const contractors = [...prevState.contractors];
      contractors.push(newData);
      return { ...prevState, contractors };
    });
  };
  onEditDataChanged = (newData: any, oldData: any) => {
    this.setState((prevState: any) => {
      const contractors = [...prevState.contractors];
      contractors[contractors.indexOf(oldData)] = newData;
      return { ...prevState, contractors };
    });
  };
  onDeleteataChanged = (oldData: any) => {
    this.setState((prevState: any) => {
      const contractors = [...prevState.contractors];
      contractors.splice(contractors.indexOf(oldData), 1);
      return { ...prevState, contractors };
    });
  };

  renderEditActivityFlowLegendsValueDialog = () => {
    return (
      <Dialog
        fullWidth={true}
        open={this.state.openEditActivityFlowLegendsValueDialog}
        onClose={() =>
          this.setState({
            openEditActivityFlowLegendsValueDialog: false,
          })
        }
      >
        <DialogTitle id="alert-dialog-title">{`Editing (${this.state.activityFlowLegendsValue.code}) ${this.state.activityFlowLegendsValue.definition}`}</DialogTitle>
        <DialogContent>
          <div
            style={{
              margin: 10,
              display: "flex",

              justifyContent: "space-evenly",
              alignItems: "center",
            }}
          >
            <TextField
              fullWidth
              id="standard-basic"
              label="Activity Code"
              inputProps={{
                maxLength: 1,
              }}
              value={this.state.activityFlowLegendsValue.code}
              placeholder="Add Activity Code"
              onChange={(event: any) => {
                let currentActivityFlowLegendsValue =
                  this.state.activityFlowLegendsValue;
                currentActivityFlowLegendsValue.code = event.target.value;
                this.setState({
                  activityFlowLegendsValue: currentActivityFlowLegendsValue,
                });
              }}
            />
            <TextField
              fullWidth
              label="Activity Definition"
              value={this.state.activityFlowLegendsValue.definition}
              placeholder="Add Activity Definition"
              onChange={(event: any) => {
                let currentActivityFlowLegendsValue =
                  this.state.activityFlowLegendsValue;
                currentActivityFlowLegendsValue.definition = event.target.value;
                this.setState({
                  activityFlowLegendsValue: currentActivityFlowLegendsValue,
                });
              }}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              this.setState({
                openEditActivityFlowLegendsValueDialog: false,
                activityFlowLegendsValue: { code: "", definition: "" },
              });
            }}
            color="primary"
          >
            No
          </Button>
          <Button
            onClick={() => {
              this.setState(
                { openEditActivityFlowLegendsValueDialog: false },
                () => {
                  let activityFlowLegends = this.state.activityFlowLegends;
                  let mItem = this.state.activityFlowLegendsValue;
                  if (this.state.nIndexActivityFlowLegendsValueSelected > -1) {
                    activityFlowLegends.splice(
                      this.state.nIndexActivityFlowLegendsValueSelected,
                      1,
                      mItem
                    );
                  }
                  this.setState({
                    activityFlowLegends: activityFlowLegends,
                    activityFlowLegendsValue: { code: "", definition: "" },
                    nIndexActivityFlowLegendsValueSelected: -1,
                  });
                }
              );
            }}
            color="primary"
            autoFocus
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  renderShiftValueDialog = () => {};

  render() {
    const { title, open, handleClose } = this.props;
    return (
      <React.Fragment>
        <Formik
          initialValues={this.getInitialValues()}
          validationSchema={addCompanyValidationSchema}
          validateOnMount={true}
          onSubmit={(values) => {
            // this.handleOnSubmit(values);
          }}
        >
          {({
            values,
            handleChange,
            handleBlur,
            errors,
            setFieldValue,
            setFieldError,
          }) => (
            <Dialog
              open={open}
              keepMounted={true}
              onClose={() => handleClose()}
              aria-labelledby="alert-dialog-slide-title"
              aria-describedby="alert-dialog-slide-description"
              fullWidth={true}
              maxWidth={"md"}
            >
              <DialogTitle id="alert-dialog-slide-title">
                <div
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    display: "flex",
                  }}
                >
                  <Typography
                    variant="h6"
                    component="h2"
                    style={{ flex: 0.5 }}
                    gutterBottom
                  >
                    {title}
                  </Typography>
                  <DialogActions>
                    <Button
                      onClick={() => {
                        handleClose();
                      }}
                    >
                      {"CANCEL"}
                    </Button>
                    <Button
                      type="submit"
                      onClick={() => this.handleOnSubmit(values)}
                    >
                      {"SAVE"}
                    </Button>
                  </DialogActions>
                </div>
              </DialogTitle>
              <Divider />
              <AppBar position="static" color="default">
                <Tabs
                  value={this.state.value}
                  onChange={(event: React.ChangeEvent<{}>, newValue: number) =>
                    this.setState({ value: newValue })
                  }
                  indicatorColor="primary"
                  textColor="primary"
                  variant="fullWidth"
                  aria-label="full width tabs example"
                >
                  <Tab label="Details" value={0} />
                  <Tab label="Operations" value={1} />
                  <Tab label="Inspections" value={2} />
                  <Tab label="Contractors" value={3} />
                  {/* <Tab label="Configuration" value={4} /> */}
                </Tabs>
              </AppBar>
              <DialogContent>
                <Form>
                  <div>
                    <TabPanel value={this.state.value} index={0}>
                      {this.renderCompanyDetailsField(
                        values,
                        handleChange,
                        handleBlur,
                        errors,
                        setFieldValue,
                        setFieldError
                      )}
                    </TabPanel>
                    <TabPanel value={this.state.value} index={1}>
                      {this.renderOperationsField(
                        values,
                        handleChange,
                        handleBlur,
                        errors,
                        setFieldValue,
                        setFieldError
                      )}
                    </TabPanel>
                    <TabPanel value={this.state.value} index={2}>
                      {this.renderInspectionField(
                        values,
                        handleChange,
                        handleBlur,
                        errors,
                        setFieldValue,
                        setFieldError
                      )}
                    </TabPanel>
                    <TabPanel value={this.state.value} index={3}>
                      <div
                        style={{
                          margin: 10,
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <TextField
                          fullWidth
                          id="standard-basic"
                          label="Contract Types"
                          value={this.state.contractingTypeValue.name}
                          placeholder="Add Contract Type"
                          onChange={(event: any) => {
                            let currentontractingTypeValue =
                              this.state.contractingTypeValue;
                            currentontractingTypeValue.name =
                              event.target.value;
                            this.setState({
                              contractingTypeValue: currentontractingTypeValue,
                            });
                          }}
                        />
                        <Button
                          variant="outlined"
                          disabled={
                            this.state.contractingTypeValue &&
                            this.state.contractingTypeValue.name &&
                            this.state.contractingTypeValue.name
                              ? false
                              : true
                          }
                          onClick={() => this.onContractingTypesAddClicked()}
                          style={{ marginLeft: 20 }}
                        >
                          ADD
                        </Button>
                      </div>
                      {this.state.contractingTypes.map(
                        (item: any, index: number) => {
                          return (
                            <ChipComponent
                              key={`chip-pos:${index.toString()}`}
                              title={item.name}
                              item={item}
                              index={index}
                              chipValue={this.state.contractingTypeValue}
                              isDisabled={
                                this.state.contractingTypeValue.name
                                  ? true
                                  : false
                              }
                              onChipDelete={(mItem: any, nIndex: any) => {
                                this.handleRemoveContractingTypesChip(
                                  mItem,
                                  nIndex
                                );
                              }}
                              onChipEdit={(mItem: any, nIndex: any) => {
                                let contractingTypes =
                                  this.state.contractingTypes;
                                contractingTypes.splice(nIndex, 1, mItem);
                                this.setState({
                                  contractingTypes: contractingTypes,
                                });
                              }}
                            />
                          );
                        }
                      )}
                      {this.state.lookupData &&
                        Object.entries(this.state.lookupData).length > 0 && (
                          <EditableTableComponent
                            title={"Contracted Companies"}
                            columns={[
                              {
                                title: "Name",
                                field: "name",
                                tableName: "Contractors",
                              },
                              {
                                title: "Contract Type",
                                field: "contractType",
                                tableName: "Contractors",
                                lookup: this.state.lookupData,
                              },
                            ]}
                            data={this.state.contractors}
                            onAddDataChanged={this.onAddDataChanged}
                            onEditDataChanged={this.onEditDataChanged}
                            onDeleteataChanged={this.onDeleteataChanged}
                          />
                        )}
                    </TabPanel>
                    <TabPanel value={this.state.value} index={4}>
                      {this.renderSchedulingFields(
                        values,
                        handleChange,
                        handleBlur,
                        errors,
                        setFieldValue,
                        setFieldError
                      )}
                    </TabPanel>
                  </div>
                </Form>
              </DialogContent>
            </Dialog>
          )}
        </Formik>
        {this.renderEditActivityFlowLegendsValueDialog()}
        {this.renderShiftValueDialog()}
        {this.renderConfirmationDialog()}
        {this.renderImagesDialog()}
        {this.renderAddCategoryDialog()}
        {this.renderAddScheduleDialog()}
        {this.renderSchedulerConfirmationDialog()}
      </React.Fragment>
    );
  }
}
export default withStyles(styles)(AddCompanyDialog);
